import { render, staticRenderFns } from "./AiLooksCatalogThingsPage.vue?vue&type=template&id=beed5228&scoped=true&"
import script from "./AiLooksCatalogThingsPage.vue?vue&type=script&lang=ts&"
export * from "./AiLooksCatalogThingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./AiLooksCatalogThingsPage.vue?vue&type=style&index=0&id=beed5228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beed5228",
  null
  
)

export default component.exports